import { FC } from "react";

export const Sending: FC = () => {
  return <>Sending</>;
};
